import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import InputIcon from "@material-tailwind/react/InputIcon";
import DataTable from "react-data-table-component";
import { Label } from "@material-tailwind/react";

export default function TableCoinMutation({tableData, pending,fromCreateAtEvent, toCreateAtEvent }) {

  function formatMongoDate(mongoDate) {

    const date = new Date(mongoDate);

    const year = date.getFullYear();
    // padStart(2, '0') memastikan ada angka 0 di depan jika hanya 1 digit
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  
  const columns = [
    {
      name: "Date Time (UTC)",
      selector: (row) => {
        
        console.log("ROW DATE :", row.created_at);
        return formatMongoDate(row.created_at);
      },
      width: "200px"
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    {
      name: "Amount",
      center: true,
      selector: (row) => {
        const formattedAmount = Number(row.amount).toLocaleString('id-ID');

        return Number(row.mut_type) === 0 ? (
          <span style={{ color: 'red' }}>{formattedAmount}</span>
        ) : (
          <span style={{ color: 'green' }}>{formattedAmount}</span>
        );
      },
    },
    {
      name: "Type",
      selector: (row) => {
        return Number(row.mut_type) === 0 ? (
          <Label color="red">Debt</Label>
        ) : Number(row.mut_type) === 1 && (
          <Label color="green">Credit</Label>
        )
      },
      center: true,
    },
    {
      name: "New Balance",
      selector: (row) => {
        const formattedBalance = Number(row.new_bal).toLocaleString('id-ID');

        return Number(row.mut_type) === 0 ? (
          <span style={{ color: 'red' }}>{formattedBalance}</span>
        ) : (
          <span style={{ color: 'green' }}>{formattedBalance}</span>
        );
      },
      right: true,
    },

  ];

  return (
    <>
      <Card>
        <h5>Advanced Search</h5>
        <CardBody>
          <div className="flex mt-4">
            <div style={{ width: '100%', display: 'flex', gap: '10px', flexDirection: "column", border: '1px solid #DCDCDC', borderRadius: '10px', padding: '20px' }}>
              <p>Filter Date</p>
              <InputIcon
                type="date"
                color="lightBlue"
                size="sm"
                outline={true}
                placeholder="From"
                iconName=""
                onChange={fromCreateAtEvent}
              />
              <InputIcon
                type="date"
                color="lightBlue"
                size="sm"
                outline={true}
                placeholder="To"
                iconName=""
                onChange={toCreateAtEvent}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      <Card className="mt-12">
        <CardHeader color="blueGray" contentPosition="left">
          <h2 className="text-white text-2xl">Coin Mutation</h2>
        </CardHeader>
        <CardBody>
          <DataTable
            columns={columns}
            data={tableData}
            progressPending={pending}
            paginationRowsPerPageOptions={[10, 50, 100, 500]}
            pagination
          />
        </CardBody>
      </Card>
    </>
  );
}
